import { render, staticRenderFns } from "./GoPeopleKeys.vue?vue&type=template&id=58e29fb1&"
import script from "./GoPeopleKeys.vue?vue&type=script&lang=js&"
export * from "./GoPeopleKeys.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\a\\1\\s\\Locate2u.AppPortal\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('58e29fb1')) {
      api.createRecord('58e29fb1', component.options)
    } else {
      api.reload('58e29fb1', component.options)
    }
    module.hot.accept("./GoPeopleKeys.vue?vue&type=template&id=58e29fb1&", function () {
      api.rerender('58e29fb1', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/TeamCarriers/components/GoPeopleKeys.vue"
export default component.exports